import { render, staticRenderFns } from "./ResultG.vue?vue&type=template&id=675c684d&"
import script from "./ResultG.vue?vue&type=script&lang=js&"
export * from "./ResultG.vue?vue&type=script&lang=js&"
import style0 from "./ResultG.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports